var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dbd7e5;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #1f3060;\n      }\n\n      .cls-3 {\n        opacity: .52;\n      }\n\n      .cls-4 {\n        fill: #edebf1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clinic"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M992.57,487.37h-197.62v-79.05h197.62v79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M794.95,487.37h158.09v355.71h-158.09v-355.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M794.95,843.07h158.09v118.57h-158.09v-118.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M649.71,210.7h184.77v79.05h-184.77v-79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M834.48,210.7v39.52h-105.72c-21.83,0-39.52-17.7-39.52-39.52h145.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.63,210.7h184.77v79.05h-184.77v-79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.4,210.7v39.52h-105.72c-21.83,0-39.52-17.7-39.52-39.52h145.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.15,684.98h513.8v276.66H281.15v-276.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M794.95,684.98v237.14h-414.99c-32.74,0-59.28-26.54-59.28-59.28v-177.85h474.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.15,289.75h513.8v395.23H281.15v-395.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M794.95,289.75v355.71h-414.99c-32.74,0-59.28-26.54-59.28-59.28v-296.42h474.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.06,487.37h158.09v355.71H123.06v-355.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M281.15,487.37v316.18h-59.28c-32.74,0-59.28-26.54-59.28-59.28v-256.9h118.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.06,843.07h158.09v118.57H123.06v-118.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M281.15,843.07v79.05h-39.52c-43.66,0-79.05-35.39-79.05-79.05h118.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.54,408.32h197.62v79.05H83.54v-79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.15,408.32v39.52h-118.57c-21.83,0-39.52-17.7-39.52-39.52h158.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M953.05,487.37v316.18h-59.28c-32.74,0-59.28-26.54-59.28-59.28v-256.9h118.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M953.05,843.07v79.05h-39.52c-43.66,0-79.05-35.39-79.05-79.05h118.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M992.57,408.32v39.52h-118.57c-21.83,0-39.52-17.7-39.52-39.52h158.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M419.48,764.03h118.57v197.62h-118.57v-197.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.05,764.03c0,168.96-1.98,158.09,0,158.09-43.66,0-79.05-35.39-79.05-79.05v-79.05h79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M538.05,764.03h118.57v197.62h-118.57v-197.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M613.11,763.96v79.05c0,43.66-35.39,79.05-79.05,79.05,1.98,0,0,10.87,0-158.09h79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.35,590.13c-1.09-10.91,6.87-20.65,17.79-21.74,10.91-1.09,20.65,6.87,21.74,17.79,1.09,10.91-6.87,20.65-17.79,21.74s-20.65-6.87-21.74-17.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.08,651.19c7.75-7.75,20.31-7.75,28.06,0,7.75,7.75,7.75,20.31,0,28.06-7.75,7.75-20.31,7.75-28.06,0-7.75-7.75-7.75-20.31,0-28.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.11,764.03c-10.91.06-19.81-8.75-19.86-19.66-.06-10.91,8.75-19.81,19.66-19.86,6.68-.03,12.93,3.31,16.61,8.89,6,9.11,3.48,21.37-5.63,27.37-3.2,2.11-6.94,3.24-10.77,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874,605.94c-10.91-.06-19.71-8.96-19.65-19.88.06-10.91,8.96-19.71,19.88-19.65,5.17.03,10.13,2.09,13.8,5.73,7.75,7.69,7.8,20.2.12,27.95-3.74,3.77-8.84,5.88-14.15,5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874,684.98c-10.91-.06-19.71-8.96-19.65-19.88.06-10.91,8.96-19.71,19.88-19.65,5.17.03,10.13,2.09,13.8,5.73,7.75,7.69,7.8,20.2.12,27.95-3.74,3.77-8.84,5.88-14.15,5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874,764.03c-10.91,0-19.76-8.85-19.76-19.76s8.85-19.76,19.76-19.76,19.76,8.85,19.76,19.76-8.85,19.76-19.76,19.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.96,447.84h98.81v158.09h-98.81v-158.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M478.77,447.84v118.57c-32.74,0-59.28-26.54-59.28-59.28v-59.28h59.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M696.15,605.94h-98.81v-158.09h98.81v158.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M696.15,447.84v118.57c-32.74,0-59.28-26.54-59.28-59.28v-59.28h59.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.62,250.23c.05,65.48-52.99,118.61-118.47,118.67-65.48.05-118.61-52.99-118.67-118.47-.03-41.41,21.54-79.84,56.91-101.38,55.93-34.05,128.88-16.31,162.93,39.62,11.29,18.55,17.27,39.84,17.29,61.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M639.23,311.88c-104.74,64.42-227.85-57.31-162.83-162.83,105.13-64.82,227.45,57.9,162.83,162.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M577.58,230.47h-19.76v-19.76c0-10.91-8.85-19.76-19.76-19.76s-19.76,8.85-19.76,19.76v19.76h-19.76c-10.91,0-19.76,8.85-19.76,19.76s8.85,19.76,19.76,19.76h19.76v19.76c0,10.91,8.85,19.76,19.76,19.76s19.76-8.85,19.76-19.76v-19.76h19.76c10.91,0,19.76-8.85,19.76-19.76s-8.85-19.76-19.76-19.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZero);
export default __webpack_public_path__ + "static/media/zero.df5b4e18ac8d68e3adaf0d9fdd5df264.svg";
export { ForwardRef as ReactComponent };